import { IDrone, IOrder, IPaginatedResponce } from "@drone-parts.garphild.pro/interfaces";
import { useQuery } from "react-query";
import { fetchDrones } from "../../../queries/drones";
import ordersStorage from "../../../storages/orders.storage";
import PrintLabel from "../../drones-page/components/print-label";
import QRCode from "qrcode";

function DronesWithOrderedItems({ order }: { order: IOrder }) {
  const ids: string[] = [];
  order.orderItems?.forEach((item) => {
    item.used?.forEach((used) => ids.push(used.droneId));
  });

  const { refetch, status, data: drones } = useQuery<IPaginatedResponce<IDrone>>(
    [
      'drones',
      {
        ids,
        showSent: true,
        page: 0,
        pageSize: 1000,
      }],
    fetchDrones,
    {
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 5,
      onSuccess: (data) => {
        ordersStorage.loadOrders();
      }
    }
  );

  const dronesList: Record<string, IDrone> = drones?.data?.reduce((acc, drone) => {
    acc[drone._id] = drone;
    return acc;
  }, {} as Record<string, IDrone>) || {};
  return (
    <div>
      {order.orderItems?.map((item) => {
        return (
          <div key={item._id}>
            <h3>{item.shortName}</h3>
            <ul>
              {item.used?.map((used) => {
                const drone = dronesList[used.droneId] || {};
                if (!drone?._id) {
                  return null;
                }
                const qrCodeData = []; //mainDroneParts.map((part) => part?.shortName?.split(/\s/).filter(m => !!m.trim()).slice(0, 2).join(" ")).slice(0,15);
                qrCodeData.unshift(drone._id);
                qrCodeData.unshift(drone.droneId.replace("Gydron", "GD"));
                const qrCode = QRCode.toDataURL(
                  qrCodeData.join("\n"),
                  {
                    errorCorrectionLevel: 'L',
                    scale: 4,
                    width: 192,
                  }
                )
                return (
                  <li key={used.droneId}>
                    {drone?.droneId} / d._id: {drone?._id} / itemId: {item._id} / status: {drone?.status} / real: {JSON.stringify(drone?.parts?.filter((part) => part.itemId === item._id)?.length)}
                    <PrintLabel drone={drone} qrCode={qrCode} />
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
}

export default DronesWithOrderedItems;
